import React from 'react';

const LegTitle = ({ legNumber }) => {
  return <div className="leg-table-header-stop">Leg {legNumber}</div>;
};
export default LegTitle;
